var render, staticRenderFns
import script from "./BaseCheckingResult.vue?vue&type=script&lang=js"
export * from "./BaseCheckingResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626cce68",
  null
  
)

export default component.exports